namespace GeniuzPOS.InitialData {
    export class PsDiscCouponTypeShopColumns {
        static columnsKey = 'InitialData.PsDiscCouponTypeShop';
    }
}
